module.exports = __webpack_public_path__ + "img/flag_blue.27ffc3dd.svg";